import {
  createCompositionAPIV1Service,
  fetchCompositionByIdService,
} from 'store/services/compositionServices';
import downloadThirdPartyImages from '../downloadThirdPartyImages';
import letrusAPI from '../../../APIs/letrusAPI/axiosInstance';

interface DownloadWriteActivityParams {
  testId: number;
  stepId?: string | number;
  themeId?: string | number;
  testCompositionId?: number;
  usesWritePreparation?: boolean;
}

export interface DownloadStatus {
  message: string;
  error?: boolean;
  success?: boolean;
  compositionId?: string | number;
}

/**
Function that fetches data from the LetrusAPI for writing and preparation
to be cached in the Service Worker, enabling activity execution while offline.
If the writing and preparation do not exist, they will be created.

@param testId - ID of test
@param stepId - ID of activity step
@param themeId - ID of the theme linked to the test
@param testCompositionId - ID of the composition linked to the test, if it exists
@param usesWritePreparation - whether this activity has writing preparation or not
@returns string success or failure message
*/

async function downloadWriteActivity({
  testId,
  stepId,
  themeId,
  testCompositionId,
  usesWritePreparation,
}: DownloadWriteActivityParams): Promise<DownloadStatus> {
  let compositionId = testCompositionId;

  try {
    if (!compositionId) {
      // creates unexistent composition
      const {data: createdComposition} = await createCompositionAPIV1Service({
        test_id: testId,
        instruction_id_id: themeId,
        step_id: stepId,
      });
      compositionId = createdComposition.id;

      await downloadThirdPartyImages(createdComposition);
    }

    // caches the composition if it already exists
    await fetchCompositionByIdService(compositionId).then(
      ({data: composition}) => {
        downloadThirdPartyImages(composition);
      },
    );

    if (usesWritePreparation) {
      // caches the write preparation
      const writePreparation = await letrusAPI(
        `/api/v1/write_preparation/${compositionId}/`,
      );
      downloadThirdPartyImages({data: writePreparation});
    }

    return {
      message: `redação ${compositionId} baixada com sucesso`,
      success: true,
      compositionId,
    };
  } catch (error) {
    return {
      message: `falha ao baixar a redação ${
        compositionId ?? `do test ${testId}`
      }`,
      error: true,
    };
  }
}

export default downloadWriteActivity;
